import type {GenericAsset} from '../../../../../brand/lib/types/contentful'
import {Image} from '@primer/react-brand/esm'
import styles from './HeroSection.module.css'

type Props = {
  component: GenericAsset
}

export function HeroCarouselBackground({component}: Props) {
  const asset = component.fields.asset?.fields
  const description = asset?.description || ''
  const file = asset?.file
  const image = file?.details?.image

  return image ? (
    <Image
      src={file.url}
      alt={description}
      width={image.width}
      height={image.height}
      className={styles.HeroCarouselBackground}
    />
  ) : null
}
